import React, { useState } from "react";

import Layout from "../../components/Layout/Layout";
import Search from "../../components/Search";

import {
  axiosinstance,
  deleteCustomer,
  getAllCustomerGroups,
  getAllCustomers,
  getWagon,
  resetcustomer,
  updateCustomer,
} from "../../utils/api";

import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import Table from "../../components/Table";
import ClientModal from "../../components/modals/ClientModal";
import CustomerQrAccessModal from "../../components/modals/CustomerQrAccessModal";
import Confirm from "../../components/modals/Confirm";
import DeleteModal from "../../components/modals/DeleteModal";
import { formatDate } from "../../utils/formatData";

const ADDCustomer = () => {
  const [open, setOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [groups, setGroups] = useState([]);
  const getAllCustomerHandler = async () => {
    setLoading(true);
    const [success, data] = await getAllCustomers();
    if (success) {
      setCustomers(
        data.map((item) => ({
          ...item,
          name: `${item.userName} ${
            item?.group?.name !== undefined ? `(${item?.group?.name})` : ""
          }`,
        }))
      );
    }
    setLoading(false);
  };

  const getAllCustomerGroupsHandler = async () => {
    setLoading(true);
    const [success, data] = await getAllCustomerGroups();
    if (success) {
      setGroups(data);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getAllCustomerHandler();
    getAllCustomerGroupsHandler();
  }, []);

  return (
    <Layout
      text="Add New Customer"
      onClick={() => {
        setOpen(true);
      }}
    >
      {loading && <Loading />}
      <div className="flex gap-3 flex-col md:flex-row">
        <Search
          data={customers.filter((item) => item?.type === "Customer")}
          item={(item) => {
            setSelected(item);
          }}
          active={selected?._id}
        />
        {selected && (
          <EditClient
            item={selected}
            reload={getAllCustomerHandler}
            setItem={setSelected}
            customers={customers}
            groups={groups}
          />
        )}
      </div>

      <ClientModal
        open={open}
        setOpen={setOpen}
        reload={getAllCustomerHandler}
        customers={customers}
        groups={groups}
        customer
      />
    </Layout>
  );
};

export default ADDCustomer;

const EditClient = ({ item, reload, setItem, customers, groups }) => {
  const [edit, setEdit] = React.useState(false);
  const [qrAccessCustomer, setQrAccessCustomer] = React.useState(null);
  const [open2, setOpen2] = React.useState(false);
  const [wagon, setWagon] = React.useState(0);
  const [showHistory, setShowHistory] = React.useState(false);
  const [history, setHistory] = React.useState([]);
  const [historyLoading, setHistoryLoading] = React.useState(false);

  const getAllWagon = async () => {
    const [success, data] = await getWagon(item?._id);
    if (success) {
      setWagon(data?.wagon);
    }
  };

  const fetchHistory = async () => {
    setHistoryLoading(true);
    try {
      const response = await axiosinstance(
        `/admin/customer-history/${item?._id}`
      );
      setHistory(response.data);
    } catch (error) {
      toast.error(error.response.data.message);
    }
    setHistoryLoading(false);
  };

  React.useEffect(() => {
    getAllWagon();
  }, [item?._id]);

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-3">
        <Table
          data={[item]}
          columns={[
            {
              title: "Username",
              dataIndex: "userName",
            },
            {
              title: "Phone Number",
              dataIndex: "phoneNumber",
            },
            {
              title: "Image",
              dataIndex: "image",
              render: (item) => (
                <a href={item.image} target="_blank" rel="noreferrer">
                  {item.image ? "View" : ""}
                </a>
              ),
            },
            {
              title: "Action",
              render: (item) => {
                return (
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        setItem({
                          ...item,
                          wagon: wagon,
                        });
                        setEdit(true);
                      }}
                      className="border mr-2 border-black px-4 py-1 bg-yellow-400 text-xl "
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => {
                        setShowHistory(true);
                        fetchHistory();
                      }}
                      className="border mr-2 border-black px-4 py-1 bg-blue-400 text-xl"
                    >
                      History
                    </button>
                    <DeleteModal
                      onClick={async () => {
                        const [success, data] = await deleteCustomer(item?._id);
                        if (success) {
                          setItem(null);
                          reload();
                          toast.success("Deleted");
                        }
                      }}
                      custom
                    >
                      <div className="border mr-2 border-black px-4 py-1 bg-red-500 text-xl ">
                        Delete
                      </div>{" "}
                    </DeleteModal>

                    <button
                      onClick={() => {
                        setOpen2(true);
                      }}
                      className="border mr-2 border-black px-4 py-1 bg-secondary text-xl "
                    >
                      Reset
                    </button>
                    {open2 && (
                      <Confirm
                        open={open2}
                        setOpen={setOpen2}
                        onClick={async () => {
                          const [success, data] = await resetcustomer(
                            item?._id
                          );
                          if (success) {
                            setOpen2(false);
                            setItem(null);
                            reload();
                            toast.success("Reset Complete");
                          }
                        }}
                      />
                    )}
                  </div>
                );
              },
            },
          ]}
        />

        {/* History Modal */}
        <Dialog
          open={showHistory}
          onClose={() => setShowHistory(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Customer History</DialogTitle>
          <DialogContent>
            {historyLoading && <Loading />}
            <Table
              data={history}
              columns={[
                {
                  title: "Updated By",
                  dataIndex: "updatedByName",
                },
                {
                  title: "Action",
                  dataIndex: "text",
                  render: (item) => {
                    return (
                      <div className="w-[30rem] flex-wrap flex-1 whitespace-pre-wrap">
                        <p>{item.text}</p>
                      </div>
                    );
                  },
                },
                {
                  title: "Date",
                  render: (item) =>
                    formatDate(item.createdAt) +
                    " " +
                    `${new Date(item.createdAt).toLocaleTimeString()}`,
                },
              ]}
            />
          </DialogContent>
        </Dialog>

        <div className="border border-black bg-green-600 px-2 py-1 w-fit">
          Clients
        </div>
        <Table
          data={item?.access}
          columns={[
            {
              title: "Username",
              dataIndex: "userName",
            },
            {
              title: "Phone Number",
              dataIndex: "phoneNumber",
            },
            {
              title: "Action",
              render: (item2) => {
                return (
                  <div className="flex gap-2">
                    <DeleteModal
                      custom
                      onClick={async () => {
                        const [success, data] = await updateCustomer(
                          item?._id,
                          {
                            ...item,
                            access: item?.access.filter(
                              (item3) => item3?._id !== item2?._id
                            ),
                          }
                        );
                        if (success) {
                          setItem({
                            ...item,
                            access: item?.access.filter(
                              (item3) => item3?._id !== item2?._id
                            ),
                          });
                          reload();
                          toast.success("Deleted");
                        }
                      }}
                    >
                      <div className="bg-red-500 px-2 py-1  border border-black">
                        Delete
                      </div>
                    </DeleteModal>
                  </div>
                );
              },
            },
          ]}
        />
      </div>

      <ClientModal
        open={edit}
        setOpen={setEdit}
        reload={reload}
        update={item}
        customers={customers}
        setUpdate={setItem}
        customer
        groups={groups}
      />
      <CustomerQrAccessModal
        open={Boolean(qrAccessCustomer)}
        setOpen={() => setQrAccessCustomer(null)}
        customer={qrAccessCustomer}
        reload={() => {
          reload();
          if (qrAccessCustomer?._id === item?._id) {
            setItem(prev => prev ? ({ ...prev, qrCodeEnabled: !prev.qrCodeEnabled }) : null);
          }
        }}
      />
    </div>
  );
};
